import { render, staticRenderFns } from "./MediaPicker.vue?vue&type=template&id=5b1c2319&scoped=true&"
import script from "./MediaPicker.vue?vue&type=script&lang=js&"
export * from "./MediaPicker.vue?vue&type=script&lang=js&"
import style0 from "./MediaPicker.vue?vue&type=style&index=0&id=5b1c2319&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1c2319",
  null
  
)

export default component.exports